import React, { useState, useEffect } from 'react';
import { Space, Radio } from 'antd';
import Styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import getColumns from '../locations/columns';
import { connect } from 'react-redux';
import { actions } from '../../../store/reducers/stakeholder';
import { actions as sclActions } from '../../../store/reducers/scl';
import { findOptions } from '../../../helpers/StringHelper';
import { useLocation, useParams } from 'react-router-dom';
import Table from '../../Table';
import { getProject } from '../../../services/BaseService';
import PageHeader from '../../Layout/PageHeader';

const Styles = Styled.div`
  .ant-page-header {
    padding: 8px 8px 8px var(--size);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .ant-page-header-heading {
			justify-content: flex-start;
    }
    .ant-page-header-heading-extra {
			display: flex;
			margin-left: var(--size);
		}
    .ant-btn {
      display: flex;
      span[role="img"] {
        font-size: 18px;
      }
    }
  }
  .ant-space {
    width: 100%;
    .ant-space-item {
      width: 100%;
    }
  }
  .ant-btn {
    display: flex;
    span[role="img"] {
      margin: auto;
    }
  }
  .ant-input-affix-wrapper-disabled  {
    background-color: transparent;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    input {
      background-color: transparent;
      cursor: text;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .columns {
    span[role="img"] {
      margin-left: 8px
    }
  }
  .projectLink {
    color: rgba(0, 0, 0, 0.7);
    font-weight: 500;
    text-decoration: underline;
  }
  .ant-drawer-body {
    padding: 0;
  }
`;

function StakeholderLocations({
  stakeholderDataGet,
  getALL,
  stakeholder: { data },
  authentication: { user },
  scl: { data: sclData, loading },
}) {
  const { t } = useTranslation();
  let columns = getColumns(t, 'pme', 'locations');
  const { id: stakeholderId } = useParams();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, showSizeChanger: true });
  const [locationsId, setLocationsId] = useState([]);
  const [scls, setScls] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const allStatuses = ['all', 'identified', 'inProgress', 'assessed', 'connected'];
  const [filterStatus, setFilterStatus] = useState(params.has('status') && allStatuses.includes(params.get('status')) ? params.get('status') : 'all');

  const project = getProject();

  useEffect(() => {
    const params = { namespace: 'Stakeholder', module: 'pme', view: 'scp', stakeholderId, project };
    stakeholderDataGet(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stakeholderId]);

  useEffect(() => {
    if (data && data['pme-scp']) {
      setLocationsId(data['pme-scp'].data.associatedMineSite.map(s => s.locationId));
    }
  }, [data]);


  useEffect(() => {
    if (locationsId.length) {
      const params = {
        status: filterStatus !== 'all' ? filterStatus : undefined,
        module: 'pme',
        id: locationsId,
        view: 'locations',
        project
      }
      getALL(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationsId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (sclData.scls) {
      const { typeOfLocationOptions, provinceOptions, territoryOptions, sclStatuses } = sclData.sclOptions || {};
      setScls(sclData.scls.map(scl => {
        const defaultStatus = { value: '--', label: '--', color: 'default' };
        const status = scl.status ? sclStatuses.find(s => s.value === scl.status) : defaultStatus;
        const province = provinceOptions.find(f => f.value === scl.administrativeLevel1);
        const territory = territoryOptions.find(f => f.value === scl.administrativeLevel2);
        return {
          id: scl.datastakeId ? scl.datastakeId : '',
          locationName: scl.locationName ? scl.locationName : '-',
          locationType: scl.category ? findOptions(scl.category, typeOfLocationOptions) : '-',
          status: status,
          territory: territory ? territory.label : '-',
          province: province ? province.label : '-',
          nrOfWorkers: scl.totalNoOfWorkers ? scl.totalNoOfWorkers : '-',
          organisationName: scl?.organisationName ? scl.organisationName : '-',
          published: scl.published,
        };
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sclData.scls]);

  return (
    <Styles className="semibold form-input-output">
      <PageHeader
        title={`${data['pme-scp'] ? data['pme-scp'].data.name : ''} ${t('Locations')}`}
      />
      <div className="column start app-content" style={{ padding: '0 18px' }}>
        <Space style={{ margin: "20px 0" }}>
          <Radio.Group value={filterStatus} onChange={(e) => {
            setFilterStatus(e.target.value);
          }}>
            <Radio.Button value="all">{t('All')}</Radio.Button>
            <Radio.Button value="identified">{t('Identified')}</Radio.Button>
            <Radio.Button value="inProgress">{t('In Progress')}</Radio.Button>
            <Radio.Button value="assessed">{t('Assessed')}</Radio.Button>
            <Radio.Button value="connected">{t('Connected')}</Radio.Button>
          </Radio.Group>
        </Space>
        <Table
          columns={columns}
          data={scls}
          pagination={pagination}
          loading={loading}
          options={{
            locationType: data.sclOptions ? sclData.sclOptions.typeOfLocationOptions : [],
            province: data.sclOptions ? sclData.sclOptions.provinceOptions : [],
            territory: data.sclOptions ? sclData.sclOptions.territoryOptions : [],
          }}
          defaultFilters={columns
            .filter(col => col.search || col.primarySearch)
            .map(col => col.dataIndex)
            .reduce((values, key) => {
              if (params.has(key)) {
                values[key] = params.get(key);
              }
              return values;
            }, {}) || {}}
          onFilterChange={(filters) => {
            let page = params.get('page');
            if (isNaN(Number(page)) || page === 'null' || page === null) {
              page = 1;
            }
          }}
          onChange={(page) => {
            if (isNaN(page.current)) {
              page.current = 1;
            }
            setPagination({
              showSizeChanger: true,
              current: page.current,
              pageSize: page.pageSize
            })
          }}
        />
      </div>
    </Styles>
  )
};

const mstp = ({ stakeholder, authentication, scl }) => ({ stakeholder, authentication, scl });

export default connect(mstp, { ...actions, ...sclActions })(StakeholderLocations);
